module.exports = __webpack_public_path__ + "ce329c8310593922bee196669f2e8fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_07.jpg
// module id = 627
// module chunks = 0